export var ClipboardUtil;
(function (ClipboardUtil) {
    /**
     * クリップボードにコピー
     * @param text
     */
    async function copy(text) {
        try {
            const clipboard = navigator.clipboard;
            await clipboard.writeText(text);
        }
        catch (error) {
            console.log('クリップボードにコピーが作成できませんでした');
        }
    }
    ClipboardUtil.copy = copy;
    /**
     * リンクを html としてコピー
     * @param text
     * @param url
     */
    async function copyLink(text, url) {
        try {
            const anchorTagText = `<a href='${url}'>${text}</a>`;
            const blob = new Blob([anchorTagText], { type: 'text/html' });
            const blobPlain = new Blob([anchorTagText], { type: 'text/plain' });
            const clipboardItem = new ClipboardItem({ 'text/html': blob, 'text/plain': blobPlain });
            const clipboardItemArray = [clipboardItem];
            const clipboard = navigator.clipboard;
            await clipboard.write(clipboardItemArray);
        }
        catch (error) {
            console.log('クリップボードにコピーが作成できませんでした');
        }
    }
    ClipboardUtil.copyLink = copyLink;
})(ClipboardUtil || (ClipboardUtil = {}));
